import { PrivacyCenterTrackingPurposePreview } from '@main/cm-types';
import { IFormInputValidatedProps, IFormItemWrapperProps } from '@main/core-ui';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { PurposeList } from './PurposeList';

export const PurposeListForm: React.FC<
  React.PropsWithChildren<
    IFormInputValidatedProps &
      Omit<IFormItemWrapperProps, 'errors'> & {
        /** configured purposes to show */
        purposes: PrivacyCenterTrackingPurposePreview[];
        /** Show the Preference topics */
        showPreferenceTopics?: boolean;
        /** When true, hide preferences if not consented */
        hideIfNotConsented?: boolean;
      }
  >
> = ({ name, ...rawInputProps }) => {
  const { control } = useFormContext();
  return (
    <>
      <Controller
        name={name}
        control={control}
        render={({ field: { ref: {} = {}, ...props } }) => (
          <PurposeList {...rawInputProps} {...props} />
        )}
      />
    </>
  );
};
